exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-tooltip{position:relative}.ba-common-tooltip [disabled]{pointer-events:none}.ba--highContrast .ba-common-tooltip__container:before{border-style:none}", ""]);

// exports
exports.locals = {
	"tooltipClassName": "\"ba-common-tooltip\""
};